import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Iconography,
  IconographySizes,
  Notification,
  NotificationVariants,
} from "@hid-galaxy-ui/galaxy-react";
import { useAppDispatch, useAppSelector } from "../../../../../../../redux";
import moment from "moment";
import EditEventModal from "./EditEventModal";
import Detail from "../detail";
import "./Overview.scss";
import { AddEvent, getFileUrl, getOverviewEventListing, getPartnerPoints, UpdateEvent } from "../../../../../../../redux/saga/partner-program/calculator/saga-action";
import { getPartnerEngagementCategoryListSagaAction } from "../../../../../../../redux/saga/partner-program/engagement-configuration/saga-actions";
import { getPartnerRegionalMultiplierListSagaAction } from "../../../../../../../redux/saga/partner-program/regional-multipliers/saga-actions";

interface TimelineItem {
  event_time: string;
  ID: any;
  event_type: string;
  event_title: string;
  event_date: string;
  id: number;
  label: string;
  labelColor: "blue" | "green" | "purple";
  date: string;
  time: string;
  title: string;
  comments: string;
  documents: Array<{
    name: string;
    url: string;
  }>;
  createdBy: string;
  createdDate: string;
}

interface EvaluationDetails {
  assessmentDay: string;
  currentTier: string;
  totalPoints: number;
  netNewLicenses: number;
  totalLicenses: string;
}

const Overview: React.FC<{ readOnly?: boolean }> = ({ readOnly = false }) => {
  const dispatch = useAppDispatch();
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [editingItem, setEditingItem] = useState<TimelineItem | null>(null);
  const [expandedComments, setExpandedComments] = useState<{
    [key: number]: boolean;
  }>({});
  const [defaultEvent, setDefaultEvent] = useState([{
    event_type: "Welcome",
    labelColor: "blue",
    event_title: "Initial welcome session with partner team",
  },
  {
    event_type: "Program Kickoff",
    labelColor: "green",
    event_title: "Official program kickoff meeting",
  },
  {
    event_type: "Partnership Kickoff Call",
    labelColor: "purple",
    event_title: "Partnership kickoff call",
  }]);
  const { partnerDetails } = useAppSelector((state) => state.partner_details);
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [selectedAssesmentData, setAssesmentData] = useState();
  const [summaryData, setSummaryData] = useState();
  const [selectedAssessmentId, setSelectedAssessmentId] = useState<
    number | null
  >(null);

  const [toasts, setToasts] = useState<any[]>([]);

  const pushMutationToast = useCallback((message: string, isError: boolean) => {
    setToasts((prev) => [
      ...prev,
      {
        id: Date.now() + Math.floor(Math.random() * 1000),
        title: "",
        message,
        variant: isError
          ? NotificationVariants.Error
          : NotificationVariants.Success,
        icon: (
          <Iconography
            icon={isError ? "ban" : "circleCheck"}
            size={IconographySizes.Medium}
          />
        ),
      },
    ]);
  }, []);

  // If detail view is active, show it



  const {
    eventOverviewList, eventPointList,fileUrl } = useAppSelector(
      (state) => state.partner_program_event_configuration
    );

  const { consentStatus } = useAppSelector(
    (state) => state.partner_program
  );
  const optedIn = consentStatus?.consent_type === 'OptIn';


  useEffect(() => {

    dispatch(getOverviewEventListing(partnerDetails?.ID));
    dispatch(getPartnerPoints(partnerDetails?.ID));
    dispatch(getPartnerEngagementCategoryListSagaAction());

  }, []);

  useEffect(() => {
    if (eventOverviewList && eventOverviewList.length) {
      const findNewSetList: { event_type: string; labelColor: string; event_title: string; }[] = [];
      defaultEvent.map((e_data, index) => {

        const existResult = eventOverviewList.find((eventData: any) => {
          return eventData.event_type === e_data.event_type

        })
        if (!existResult) {
          findNewSetList.push(e_data)
        }

      })

      setDefaultEvent([...findNewSetList])

    }
  }, [eventOverviewList])

  useEffect(() => {
    if (!showDetailView || selectedAssessmentId == null || !eventPointList?.length)
      return;
    const row = eventPointList.find(
      (p: any) =>
        (p.record?.ID ?? p.record?.id) === selectedAssessmentId
    );
    if (row?.record) {
      setAssesmentData(row.record);
      setSummaryData(row.summary);
    }
  }, [eventPointList, showDetailView, selectedAssessmentId]);






  const evaluationDetails: EvaluationDetails = {
    assessmentDay: "25 Nov 2025",
    currentTier: "Select",
    totalPoints: 16162.5,
    netNewLicenses: 4300,
    totalLicenses: "15 Oct 2025",
  };

  const handlePrevious = () => {
    setSelectedIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setSelectedIndex((prev) => Math.min(eventPointList.length - 1, prev + 1));
  };

  const handleEditClick = (item: any) => {
    setEditingItem(item);
    setIsEditModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsEditModalOpen(false);
    setEditingItem(null);
  };

  const handleSaveEvent = (data: any) => {
    // TODO: Implement save logic with Redux
    const formData = new FormData();
    if (data && data.documents && data.documents.length) {
      formData.append('event_date', data.event_date)
      formData.append('event_time', data.event_time)
      formData.append('event_title', data.event_title)
      formData.append('event_type', data.event_type)
      formData.append('comments', data.comments)
      formData.append('partner_id', partnerDetails.ID.toLocaleString())
      data.documents.map((d_data: any) => {
        formData.append('documents', d_data)
      })
      if (data.ID) {
        formData.append('ID', data.ID)
        dispatch(UpdateEvent(formData));
      } else {
        dispatch(AddEvent(formData));
      }
    } else {
      if (data.ID) {
        dispatch(UpdateEvent({
          ...data,
          documents:null,
          partner_id: partnerDetails.ID
        }));
      } else {
        dispatch(AddEvent({
          ...data,
           documents:null,
          partner_id: partnerDetails.ID
        }));
      }
    }

    console.log("data", data)


    console.log("Saving event data:", data);
  };

  const toggleCommentExpansion = (itemId: number) => {
    setExpandedComments((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };


  const downloadFileUrlFn=(fileName:any,fileType:any)=>{

    dispatch(getFileUrl(fileName,fileType));

  }

  return (
    <div className="overview-container">
      <Notification toasts={toasts} setToasts={setToasts} />
      {!showDetailView ?
        <>

          <div className="overview-content overview-content-fixed-event-first-time">
            {/* Timeline Section */}
            <div className={eventPointList && eventPointList.length ? 'timeline-section' : 'full-timeline-section'}>

              {eventOverviewList && eventOverviewList.length ?
                eventOverviewList.map((item: any, index: number) => (
                  <div
                    key={item.ID}
                    className={`timeline-card`}
                  >
                    <div className="timeline-card-header">
                      <div className="timeline-header-left">
                        <span className={`timeline-label ${item.event_type === 'Welcome' ? 'blue' : (
                          item.event_type === 'Program Kickoff' ? 'green' : 'purple'
                        )}`}>
                          {item.event_type}
                        </span>
                        <div className="timeline-meta">
                          <Iconography
                            icon="calendar"
                            size={IconographySizes.Small}
                          />
                          <span>{moment(item.event_date).format("DD-MM-YYYY")}</span>
                          {item.event_time ?
                            <>

                              <span className="dot">•</span>
                              <Iconography icon="clock" size={IconographySizes.Small} />
                              <span>{item.event_time}</span>
                            </>
                            : ''}
                        </div>
                      </div>
                    </div>
                    {/* <div className="timeline-card-subheader">
                <span>Created by {item.createdBy}</span>
                <span className="dot">•</span>
                <span>{item.createdDate}</span>
              </div> */}
                    <span className="timeline-title">{item.event_title ? item.event_title :
                      'Initial welcome session with partner team'}</span>
                    <p className="timeline-label-small">Comment</p>
                    <p className="timeline-comment">
                      {/* {expandedComments[item.ID]
                      ? item.comments
                      : `${item.comments.substring(0, 100)}...`}{" "}
                    {item.comments.length > 100 && (
                      <span
                        className="more-link"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleCommentExpansion(item.ID);
                        }}
                      >
                        {expandedComments[item.ID] ? "Less" : "More"}
                      </span>
                    )} */}

                      {item.comments}
                    </p>
                    <div className="timeline-documents">
                      <div className="documents-list">
                         {item.documents && item.documents.length ? 
                        <span className="documents-label">Documents</span> : ''}
                        {item.documents && item.documents.length ? item.documents.map((doc: any, docIndex: number) => (
                          <a 
                          //target="_blank"
                          onClick={()=>{
                            downloadFileUrlFn(doc,'view')
                          }}
                           key={docIndex} 
                           //href={doc} 
                           className="document-item">
                            <span className="document-link">{doc}</span>
                            <Iconography
                              icon="download"
                              size={IconographySizes.Small}
                              className="download-icon"
                            />
                          </a>
                        )):''}
                      </div>
                      <div className="edit-button">
                        <Button
                          variant="tertiary"
                          label="EDIT"
                          icon={
                            <Iconography icon="pen" size={IconographySizes.Small} />
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEditClick(item);
                          }}
                          disabled={!optedIn || readOnly}
                        />
                      </div>
                    </div>
                  </div>
                )) : ''}

              {defaultEvent.map((item, index) => (
                <div
                  key={item.event_type}
                  className={`timeline-card`}
                >
                  <div className="timeline-card-header">
                    <div className="timeline-header-left">
                      <span className={`timeline-label ${item.labelColor}`}>
                        {item.event_type}
                      </span>

                    </div>
                  </div>

                  <div className="timeline-documents">
                    <span className="timeline-title">{item.event_title}</span>
                    <div className="edit-button">
                      <Button
                        variant="tertiary"
                        label="EDIT"
                        icon={
                          <Iconography icon="pen" size={IconographySizes.Small} />
                        }
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditClick(item);
                        }}
                        disabled={!optedIn || readOnly}
                      />
                    </div>
                  </div>


                </div>
              ))}
            </div>


            {/* Evaluation Details Section - Right Side */}

            {eventPointList && eventPointList.length ?

              <div className="evaluation-section">
                <div className="evaluation-header">
                  <h2>Latest Evaluation Details</h2>
                  <div className="navigation-buttons">
                    <Button
                      variant="secondary"
                      icon={
                        <Iconography
                          icon="chevronLeft"
                          size={IconographySizes.Small}
                        />
                      }
                      onClick={handlePrevious}
                      disabled={selectedIndex === 0}
                    />
                    <Button
                      variant="secondary"
                      icon={
                        <Iconography
                          icon="chevronRight"
                          size={IconographySizes.Small}
                        />
                      }
                      onClick={handleNext}
                      disabled={selectedIndex === eventPointList.length - 1}
                    />
                  </div>
                </div>

                {eventPointList.map((point_data: any, index: number) => (
                  <>
                    {index === selectedIndex &&
                      <>
                        <div className="evaluation-cards">
                          <div className="eval-card blue-light">
                            <div className="eval-content">
                              <div className="eval-left">
                                <Iconography icon="calendar" size={IconographySizes.Medium} />
                                <span className="eval-label">Assessment Day</span>
                              </div>
                              <span className="eval-value">
                                {moment(point_data.record.assessment_date).format("DD-MM-YYYY")}
                              </span>
                            </div>
                          </div>

                          <div className="eval-card green-light">
                            <div className="eval-content">
                              <div className="eval-left">
                                <Iconography icon="award" size={IconographySizes.Medium} />
                                <span className="eval-label">Current Tier</span>
                              </div>
                              <span className="eval-value">
                                {point_data.record.tier_name || 'Registered'}
                              </span>
                            </div>
                          </div>

                          <div className="eval-card yellow-light">
                            <div className="eval-content">
                              <div className="eval-left">
                                <Iconography
                                  icon="arrowTrendUp"
                                  size={IconographySizes.Medium}
                                />
                                <span className="eval-label">Total Points</span>
                              </div>
                              <span className="eval-value">
                                {point_data.record.total_partner_points || 0}
                              </span>
                            </div>
                          </div>

                          <div className="eval-card purple-light">
                            <div className="eval-content">
                              <div className="eval-left">
                                <Iconography
                                  icon="circleStar"
                                  size={IconographySizes.Medium}
                                />
                                <span className="eval-label">Net New Licenses</span>
                              </div>
                              <span className="eval-value">
                                {point_data.record.partner_new_licenses || 0}
                              </span>
                            </div>
                          </div>

                          <div className="eval-card cyan-light">
                            <div className="eval-content">
                              <div className="eval-left">
                                <Iconography
                                  icon="fileCheck"
                                  size={IconographySizes.Medium}
                                />
                                <span className="eval-label">Total Licenses</span>
                              </div>
                              <span className="eval-value">
                                {point_data.record.partner_total_licenses || 0}
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="view-detail-button">
                          <Button
                            variant="tertiary"
                            label="VIEW DETAIL"
                            icon={
                              <Iconography icon="arrowRight" size={IconographySizes.Small} />
                            }
                            onClick={() => {
                              const rid =
                                point_data.record?.ID ?? point_data.record?.id;
                              if (rid != null) setSelectedAssessmentId(Number(rid));
                              setAssesmentData(point_data.record);
                              setSummaryData(point_data.summary);
                              setShowDetailView(true);
                            }}
                          />
                        </div>
                      </>
                    }
                  </>
                ))}


              </div> : ''}

          </div>




        </>
        :
        <Detail
          selectedAssesmentData={selectedAssesmentData}
          summaryDat={summaryData}
          partnerId={partnerDetails?.ID}
          readOnly={readOnly}
          onMutationToast={pushMutationToast}
          onRefresh={() => {
            if (partnerDetails?.ID != null) {
              dispatch(getPartnerPoints(partnerDetails.ID));
            }
          }}
          onBack={() => {
            setShowDetailView(false);
            setSelectedAssessmentId(null);
          }}
        />
      }

      {/* Edit Event Modal */}
      {isEditModalOpen && editingItem && (
        <EditEventModal
          isOpen={isEditModalOpen}
          onClose={handleCloseModal}
          eventData={{
            label: editingItem.label,
            event_date: editingItem.event_date,
            event_time: editingItem.event_time,
            event_title: editingItem.event_title,
            event_type: editingItem.event_type,
            comments: editingItem.comments,
            documents: editingItem.documents,
            ID: editingItem.ID
          }}
          onSave={handleSaveEvent}
        />
      )}
    </div>
  );
};

export default Overview;
